import { baseApiService } from './api/base'
import type {
  PerformanceData,
  ActiveSessionsResponse,
  ServerVersionResponse,
  BackgroundStatusResponse
} from '../types/systemInformation'

export const systemInformationService = {
  getPerformanceView: async (): Promise<PerformanceData> => {
    return baseApiService.fetch<PerformanceData>('/api/performanceview')
  },

  getPerformanceViewBgStatus: async (): Promise<BackgroundStatusResponse> => {
    return baseApiService.fetch<BackgroundStatusResponse>('/api/performanceview/bgtasksstatus', {
      params: { _noLoadingSpinner: true }
    })
  },

  getActiveSessionsStatus: async (): Promise<ActiveSessionsResponse> => {
    return baseApiService.fetch<ActiveSessionsResponse>('/api/performanceview/activeSessions', {
      params: { _noLoadingSpinner: true }
    })
  },

  getServerVersion: async (): Promise<ServerVersionResponse> => {
    return baseApiService.fetch<ServerVersionResponse>('/version')
  },

  getAllSystemData: async () => {
    const [performanceViewBgStatus, performanceView, activeSessionsStatus, serverVersion] = await Promise.all([
      systemInformationService.getPerformanceViewBgStatus(),
      systemInformationService.getPerformanceView(),
      systemInformationService.getActiveSessionsStatus(),
      systemInformationService.getServerVersion()
    ])

    return {
      performanceViewBgStatus,
      performanceView,
      activeSessionsStatus,
      serverVersion
    }
  }
}
